<template>
    <div
        v-loading="loading"
        class="check-record"
        element-loading-text="拼命加载中"
        element-loading-background="rgba(255,255,255,0)"
    >
        <p class="check-record-tips">
            违禁词检测记录只保留<em class="red">30</em>天，30天后就会自动清楚且无法恢复，请及时处理检测结果
        </p>
        <div v-show="!showPayPage" class="check-record-container mt20 p20">
            <div class="select-box dfc mb20">
                <div class="dfc">
                    <span>状态：</span
                    ><el-select
                        v-model="statusValue"
                        placeholder="请选择"
                        size="small"
                        style="width: 100px"
                        @change="getData(1)"
                    >
                        <el-option
                            v-for="item in statusOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        />
                    </el-select>
                </div>
                <div class="dfc ml40">
                    <span>检测范围： </span
                    ><el-select
                        v-model="checkRange"
                        placeholder="请选择"
                        size="small"
                        style="width: 100px"
                        @change="getData(1)"
                    >
                        <el-option
                            v-for="item in checkRangeOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        />
                    </el-select>
                </div>
            </div>
            <el-table :data="tableData" style="width: 100%" :header-cell-style="tableHeader">
                <div slot="empty">
                    <span v-if="!loading && tableData.length === 0">暂无数据~</span>
                </div>
                <el-table-column
                    label="检测开始时间"
                    prop="checkTime"
                    width="160"
                    align="center"
                    header-align="center"
                />
                <el-table-column label="检测范围" align="center" header-align="center">
                    <template #default="{ row }">
                        <span>{{ position[row.offerStatus] }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="实付金额（元）"
                    prop="cost"
                    align="center"
                    header-align="center"
                    min-width="120"
                />
                <el-table-column
                    label="检测产品数"
                    prop="offerCount"
                    align="center"
                    header-align="center"
                    min-width="90"
                />
                <el-table-column label="待处理产品数" width="115" align="center" header-align="center">
                    <template #default="{ row }">
                        <span v-if="row.planState === 0">未检测</span>
                        <span v-else-if="row.planState === 1">{{ row.state === 3 ? '已取消' : '检测中' }}</span>
                        <span v-else-if="row.planState > 1" style="color: red">{{ row.undeclaredCount }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="检测项" prop="checkItem" width="240" align="center" header-align="center">
                    <template #default="{ row }">
                        <el-tooltip class="item" effect="dark" :content="row.checkItem" placement="top">
                            <span class="w200 dlb textOver">{{ row.checkItem }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column label="检测进度" align="center" header-align="center">
                    <template #default="{ row }">
                        <span v-if="row.planState === 0">0%</span>
                        <span v-else-if="row.planState === 1">0%</span>
                        <span v-else-if="row.planState > 1">100%</span>
                    </template>
                </el-table-column>
                <el-table-column label="状态" width="100" align="center" header-align="center">
                    <template #default="{ row }">
                        <span v-if="row.planState !== 1" :class="{ red: row.planState === 3 }">{{
                            status[row.planState]
                        }}</span>
                        <span v-else>{{ row.state === 3 ? '已取消' : '检测中' }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="210" align="center" header-align="center">
                    <template #default="{ row }">
                        <div style="color: #0064c1" class="check-record-operation">
                            <div v-if="row.planState === 0">
                                <span @click="gotoPay(row)">去支付</span
                                ><span @click="delOrder(row.planNo)">删除订单</span>
                            </div>
                            <div v-else-if="row.planState === 1">
                                <span v-if="row.state !== 3" @click="checkProgress(row)">查看进度</span>
                                <span v-else class="gray">查看进度</span>
                            </div>
                            <div v-else-if="row.planState > 2 && row.planOfferExitCount === 0" class="gray">
                                <span>查看报告</span><span>重新检测</span>
                            </div>
                            <div v-else-if="row.planState > 2 && row.planOfferExitCount !== 0">
                                <span @click="checkReport(row)">查看报告</span>
                                <el-tooltip effect="dark" placement="top-end" :disabled="row.executeCount >= 0">
                                    <div slot="content">{{ row.checkTime }}&nbsp;已重新检测</div>
                                    <span :class="{ gray: row.executeCount < 0 }" @click="recheck(row)">重新检测</span>
                                </el-tooltip>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div v-show="tableData.length" class="mt10 tr">
                <el-pagination
                    background
                    :current-page="query.index"
                    :page-size="query.size"
                    :page-sizes="[10, 20, 30, 40, 50]"
                    layout="pager, sizes, total, jumper"
                    :total="query.total"
                    @current-change="handleCurrentChange"
                    @size-change="handleSizeChange"
                />
            </div>
        </div>
        <div v-show="showPayPage" class="pay-page mt20 p20 font14">
            <p>购买者：{{ paidInfo.Purchaser }}</p>
            <p class="mt20 mb20">订单时间：{{ paidInfo.CreateTime }}</p>
            <el-table :data="paidTable" style="width: 100%" :header-cell-style="tableHeader">
                <el-table-column label="检测内容" align="center" header-align="center" width="270">
                    <template #default="{ row }">
                        <div v-if="row"><div v-html="row.title"></div></div>
                    </template>
                </el-table-column>
                <el-table-column prop="selectedPro" label="已选产品数（个）" align="center" header-align="center" />
                <el-table-column prop="freeNum" label="免费检测数（个）" align="center" header-align="center" />
                <el-table-column prop="paidNum" label="付费检测数（个）" align="center" header-align="center" />
                <el-table-column prop="originalPrice" align="center" header-align="center">
                    <template #header>
                        <p>原价</p>
                        <p>（元/个）</p>
                    </template>
                </el-table-column>
                <el-table-column align="center" header-align="center">
                    <template #header>
                        <p>优惠价</p>
                        <p>（元/个）</p>
                    </template>
                    <template #default="{ row }">
                        <span class="red">{{ row.concessionalRate }}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" header-align="center">
                    <template #header>
                        <p>应付款</p>
                        <p>（元）</p>
                    </template>
                    <template #default="{ row }">
                        <span class="red">{{ row.accountsPayable }}</span>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pay-money pt18 tr pr35 color66 lh15">
                <p class="mt5">
                    原价：{{ paidInfo.OfferCount }}（已选产品数）*0.2元={{ (paidInfo.OfferCount * 0.2).toFixed(2) }}元
                </p>
                <p class="mt5">已优惠：{{ (paidInfo.OfferCount * 0.2 - paidInfo.OriginalPrice).toFixed(2) }}元</p>
                <p>
                    实付款<font class="font12">（本次检测费用）：</font
                    ><font class="red font24 fontWB">￥{{ paidInfo.OriginalPrice }}</font>
                </p>
                <el-button type="primary" size="medium" class="mt20 mb20" @click="payPageBan">支付并检测</el-button>
            </div>
        </div>
        <check-report ref="checkReport" @requestList="getData" />
        <taskProgress ref="taskProgress" />
        <pay-dialog ref="payDialog" />
        <newTaskProgress ref="newTaskProgress" />
    </div>
</template>

<script>
import checkReport from '../components/checkReport';
import payDialog from '../components/payDialog';
import taskProgress from '../components/common/progress/progress.vue';
import { cloneDeep } from 'lodash';
import newTaskProgress from '../components/common/progress/newProgress.vue';
export default {
    name: 'CheckRecord',
    components: {
        checkReport,
        taskProgress,
        payDialog,
        newTaskProgress,
    },
    data() {
        return {
            loading: false,
            tableData: [],
            status: ['待支付', '检测中', '检测完成', '待处理', '处理完成', '未检出'],
            fwCheckTypes: ['文字违禁词', '图片违禁词', '', '属性违禁词', 'SKU违禁词'],
            statusValue: '', // 状态
            statusOptions: [], // 状态选项
            checkRange: '', // 检测范围
            checkRangeOptions: [
                {
                    label: '全部',
                    value: '',
                },
                {
                    label: '销售中',
                    value: 2,
                },
                {
                    label: '待上架',
                    value: 7,
                },
            ], // 检测范围选项
            position: {
                2: '销售中',
                13: '草稿箱',
                7: '待上架',
            },
            tableHeader: {
                background: '#ebecf1',
                color: '#4c4b4b',
                fontSize: '14px',
                fontWeight: 'normal',
            }, // 表头样式
            query: {
                index: 1,
                size: 10,
                total: 0,
            },
            showPayPage: false, // 显示订单页
            paidInfo: {}, // 订单信息
            paidTable: [], // 订单列表
            payListEdition: true,
        };
    },
    created() {
        const arr = [{ label: '全部', value: '' }];
        for (let i = 1; i < this.status.length; i++) {
            const str = this.status[i];
            if (!str) {
                continue;
            }
            arr.push({
                label: str,
                value: i,
            });
        }
        this.statusOptions = Object.freeze(arr);
        this.$bus.$on('openNewTaskProgress', this.openNewTaskProgress);
    },
    destroyed() {
        this.$bus.$off('openNewTaskProgress', this.openNewTaskProgress);
    },
    mounted() {
        this.getData();
    },
    methods: {
        getData(index) {
            // 列表数据
            let that = this;
            if (index) {
                this.query.index = index;
            }
            this.loading = true;
            let params = {
                PageIndex: this.query.index,
                PageSize: this.query.size,
            };
            if (this.statusValue || this.statusValue === 0) {
                params.planState = this.statusValue;
            }

            if (this.checkRange) {
                params.offerStatus = this.checkRange;
            }
            this.$ajax.post('api/tiktok/ForbiddenWordPlan/search', params).then((res) => {
                this.loading = false;
                if (res.code !== 200) {
                    this.tableData = [];
                    this.$message.warning(res.msg);
                    return;
                }
                for (let i = 0, len = res.result.list.length; i < len; i++) {
                    if (res.result.list[i].checkTime === '0001-01-01 00:00:00') {
                        res.result.list[i].checkTime = '--';
                    }
                    if (res.result.list[i].executeCount > 1 && res.result.list[i].fwCheckTypes.indexOf(1) > -1) {
                        res.result.list[i].executeCount = -1;
                    }
                    if (res.result.list[i].createTime < '2019-04-28 23:59:59') {
                        res.result.list[i].fwCheckTypes.push(2);
                    }
                    res.result.list[i].checkItem = res.result.list[i].fwCheckTypes
                        .map((v) => that.fwCheckTypes[v])
                        .join('+');
                }
                this.tableData = res.result.list;
                this.query.total = res.result.totalCount;
            });
        },
        handleCurrentChange(index) {
            // 翻页
            this.query.index = index;
            this.getData();
        },
        handleSizeChange(val) {
            this.query.size = val;
            this.getData();
        },

        gotoPay(row) {
            // 去支付
            this.loading = true;
            this.$ajax.post('app/ali/existtask', { tag: '批量违禁词检测' }).then((res) => {
                this.loading = false;
                if (!res.Data) {
                    this.showPayPage = true; // 展示付款页
                    const paidInfo = cloneDeep(row); // 行数据
                    paidInfo.Detailed = JSON.parse(paidInfo.Detailed);
                    let paymentSwitch = true;
                    const arr = [];
                    if (!paidInfo.FwCheckTypes[0] == 1) {
                        paymentSwitch = false;
                    }
                    if (!paymentSwitch && this.payListEdition) {
                        arr[0] = {
                            title: '文字（标题+详情）',
                            selectedPro: paidInfo.OfferCount,
                            freeNum: paidInfo.OfferCount,
                            paidNum: 0,
                            originalPrice: 0,
                            concessionalRate: 0,
                            accountsPayable: 0,
                        };
                    }
                    let freeNum, paidNum, concessionalRate;
                    if (paymentSwitch) {
                        freeNum = (paidInfo.Detailed && paidInfo.Detailed[0] && paidInfo.Detailed[0].FreeCount) || '';
                        paidNum = (paidInfo.Detailed && paidInfo.Detailed[0] && paidInfo.Detailed[0].PayCount) || '';
                        concessionalRate =
                            (paidInfo.Detailed && paidInfo.Detailed[0] && paidInfo.Detailed[0].UnitPrice) || '';
                    } else {
                        freeNum = (paidInfo.Detailed && paidInfo.Detailed[1] && paidInfo.Detailed[1].FreeCount) || '';
                        paidNum = (paidInfo.Detailed && paidInfo.Detailed[1] && paidInfo.Detailed[1].PayCount) || '';
                        concessionalRate =
                            (paidInfo.Detailed && paidInfo.Detailed[0] && paidInfo.Detailed[0].UnitPrice) || '';
                    }
                    arr.push({
                        title: this.payListEdition
                            ? '图片违禁词（主图+详情图）'
                            : '<p>文字（标题+详情）+  图片违禁词</p><p>（主图+详情图）</p>',
                        selectedPro: paidInfo.OfferCount,
                        freeNum,
                        paidNum,
                        originalPrice: 0.2,
                        concessionalRate,
                        accountsPayable: paidInfo.OriginalPrice,
                    });
                    // let rangeWord = false; //是否选中方正字体
                    // if (paidInfo.FwCheckTypes.indexOf("2") > 0) {
                    //   //判断是否选中方正字体
                    //   rangeWord = true;
                    // } else {
                    //   rangeWord = false;
                    // }
                    // if (rangeWord) {
                    //   arr.push({
                    //     title: "图片方正字体（主图+详情图）",
                    //     selectedPro: paidInfo.OfferCount,
                    //     freeNum: paidInfo.OfferCount,
                    //     paidNum: 0,
                    //     originalPrice: 0,
                    //     concessionalRate: 0,
                    //     accountsPayable: 0,
                    //   });
                    // }
                    this.paidInfo = paidInfo;
                    this.paidTable = arr;
                } else {
                    this.$message.warning('您还有任务在执行中，请等任务结束后再进行支付哦！');
                }
            });
        },
        payPageBan() {
            // 支付并检测
            const { PlanNo, Cost } = this.paidInfo;
            this.loading = true;
            dazeTask.register(PlanNo, (data) => {
                if (data.State == 'payment') {
                    if (data.FwTaskId == '') {
                        data.FwTaskId = PlanNo;
                    }
                    const options = {
                        taskId: data.FwTaskId,
                        taskName: '正在进行检测违禁词', // 任务展示的名称
                        btns: [
                            {
                                name: '后台运行',
                                type: 'primary',
                                autoClose: true, // 点击按钮的时候 是否自动关闭进度条
                                callback: () => {
                                    //
                                },
                            },
                        ],
                        callBack: () => {
                            this.showPayPage = false;
                            this.$refs.payDialog.close();
                            this.getData();
                        }, // 任务完成回调
                    };
                    this.$refs.taskProgress.show(options);
                }
            });
            this.$ajax.post('app/to/payqrcodeurl', { planNo: PlanNo }).then((res) => {
                this.loading = false;
                if (!res.Success) {
                    this.$message.warning(res.Tips);
                    return;
                }
                this.$refs.payDialog.show({
                    Cost,
                    payImg: res.Data,
                });
            });
        },
        delOrder(planNo) {
            // 删除订单
            this.loading = true;
            this.$ajax.post('app/to/deleteplan', { planNo }).then((res) => {
                this.loading = false;
                if (!res.Success) {
                    this.$message.warning(res.Tips);
                    return;
                }
                this.$message.success('删除订单成功');
                if (this.query.index !== 1) {
                    if (this.tableData.length - 1 <= 0) {
                        this.query.index -= 1;
                    }
                }
                this.getData();
            });
        },
        checkProgress(row) {
            const options = {
                taskId: row.taskId,
                taskName: '正在进行检测违禁词', // 任务展示的名称
                btns: [
                    {
                        name: '后台运行',
                        type: 'primary',
                        autoClose: true, // 点击按钮的时候 是否自动关闭进度条
                        callback: () => {},
                    },
                ],
                callBack: () => {
                    this.getData(1);
                }, // 任务完成回调
            };
            // this.$refs.taskProgress.show(options);
            this.$refs.newTaskProgress.show(options);
        },
        checkReport(row) {
            // 查看报告
            this.$refs.checkReport.show(row);
        },
        recheck(row) {
            // 重新检测
            if (row.executeCount < 0) {
                return;
            }
            this.$bus.$emit('openNewTaskProgress', {
                url: 'api/tiktok/ForbiddenWordPlan/CheckOfferForbiddenWord',
                taskName: '正在执行中',
                data: {
                    planNo: row.planNo,
                },
                btns: [
                    {
                        name: '取 消',
                        type: '',
                        autoClose: false, // 点击按钮的时候 是否自动关闭进度条,yo
                        callback: this.cancelTask,
                    },
                    {
                        name: '后台运行',
                        type: 'primary',
                        autoClose: true, // 点击按钮的时候 是否自动关闭进度条
                        callback: () => {},
                    },
                ],
                callBack: () => {
                    this.getData();
                },
            });
            // this.$refs.taskProgress.show({
            //   url: "app/to/checkofferfwv2",
            //   data: {
            //     planNo: row.PlanNo,
            //   },
            //   btns: [
            //     {
            //       name: "后台运行",
            //       type: "primary",
            //       autoClose: true, // 点击按钮的时候 是否自动关闭进度条
            //       callback: (type) => {},
            //     },
            //   ],
            //   callBack: (res) => {
            //     this.getData();
            //   },
            // });
        },
        openNewTaskProgress(options, callback) {
            this.$refs.newTaskProgress.show(options);
            callback && callback(this.$refs.newTaskProgress);
        },
        cancelTask(component) {
            const cancelTip = '是否取消当前任务';
            this.$confirm(cancelTip, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                dangerouslyUseHTMLString: true,
                type: 'warning',
            })
                .then(() => {
                    component.isOpen = false;
                    this.loading = true;
                    this.$ajax
                        .post('api/tiktok/Task/cancel', {
                            taskId: component.progressData.taskId,
                        })
                        .then((res) => {
                            this.loading = false;
                            if (res.code === 200) {
                                component.dialogVisible = false;
                                this.$message.success(this.successTip || '取消成功!');
                                // this.getData();
                                this.$emit('getRecordList');
                            } else {
                                this.$message.warning('取消失败');
                            }
                        })
                        .catch(() => {
                            this.loading = false;
                        });
                })
                .catch(() => {
                    component.isOpen = true;
                });
        },
    },
};
</script>
<style lang="scss" scoped>
.check-record {
    font-size: 14px;
    line-height: 1.5em;
    color: #666666;
    .gray {
        color: #a5a5a5;
    }
    .red {
        color: #e91b00;
    }
    .check-record-operation {
        color: #0064c1;
        span {
            cursor: pointer;
            &:first-child {
                margin-right: 5px;
            }
        }
    }
    .check-record-tips {
        width: 100%;
        height: 35px;
        font: 12px '思源黑体';
        line-height: 35px;
        border: 1px solid #edd478;
        background-color: #fff6cb;
        text-align: left;
        text-indent: 20px;
        .red {
            color: #e56933;
        }
    }
    .check-record-container {
        background-color: #fff;
        color: #666666;
        // .select-box {
        // }
    }
    .pay-page {
        background-color: #fff;
        color: #666666;
        .pay-money {
            background-color: #f0f7fc;
        }
    }
}
</style>
